module.exports = __webpack_public_path__ + "static/media/default.0e583f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/entries/default.png
// module id = 1078
// module chunks = 0